import { render, staticRenderFns } from "./MyProfileEdit.vue?vue&type=template&id=0cd0a9ae&scoped=true&"
import script from "./MyProfileEdit.vue?vue&type=script&lang=js&"
export * from "./MyProfileEdit.vue?vue&type=script&lang=js&"
import style0 from "./MyProfileEdit.vue?vue&type=style&index=0&id=0cd0a9ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd0a9ae",
  null
  
)

export default component.exports